<div
    *ngIf="canView"
    class="changelog-button-wrapper relative inline-flex"
    [matTooltip]="'What\'s new' | transloco"
    matTooltipPosition="below"
>
    <ac-button type="icon" (clicked)="openChangelog()">
        <mat-icon [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
    </ac-button>

    <span
        *ngIf="unreadCount > 0"
        class="changelog-badge absolute -top-1 -right-1 flex items-center justify-center min-w-4 h-4 px-1 rounded-full bg-primary text-white text-[10px] font-semibold leading-none pointer-events-none"
    >
        {{ unreadCount > 9 ? "9+" : unreadCount }}
    </span>
</div>
